module.exports = __webpack_public_path__ + "static/media/logo162.635e75f3.png";